<template>
    <Form v-slot="slotProps" @submit="onSubmit">
        <slot v-bind="slotProps" />
    </Form>
</template>

<script lang="ts" setup>
    import { Form } from 'vee-validate'
    import type { GenericObject, SubmissionContext } from 'vee-validate'

    // Forward vee-validate's submit payload so a submit handler can reset the
    // form's validation state after a successful submit (e.g. clearing password
    // fields without them flagging as required). Existing handlers that take no
    // args keep working — the extra args are simply ignored.
    const emit = defineEmits<{ (e: 'submit', values: GenericObject, ctx: SubmissionContext): void }>()

    const onSubmit = (values: GenericObject, ctx: SubmissionContext) => emit('submit', values, ctx)
</script>
